/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const GreenLem: any = (props: {}) => {
  return (
    <svg width="94" height="169" viewBox="0 0 94 169" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.345 50.5792C63.9264 50.5792 87.6 69.5008 87.6 102.206C87.6 132.518 62.87 153.834 31.345 153.834C-1.5396 153.834 -23.2942 132.682 -24.9223 99.1132C-26.3342 69.9095 -8.7406 19.1442 47.8673 0L50.6968 5.57614C35.6875 15.8435 24.072 31.9615 22.5308 42.2739C21.0983 51.865 28.7541 50.5792 31.345 50.5792"
        fill="#529628"
      />
      <path
        d="M44.904 82.5827L44.9041 82.5824C47.1413 72.527 53.3942 64.6773 64.7724 62.7599L64.7725 62.7599C73.9588 61.2111 81.9091 64.2984 86.8466 69.9048C91.781 75.5077 93.7759 83.7045 90.8905 92.5372C89.5541 96.5264 87.6373 100.295 85.2018 103.72L85.2003 103.723C73.9183 119.684 62.5147 135.56 50.7806 151.896C47.2017 156.878 43.592 161.904 39.9457 166.987L29.2348 162.509C30.6715 155.039 32.068 147.571 33.463 140.111C37.0643 120.854 40.6558 101.648 44.904 82.5827Z"
        stroke="#1B0D07"
        strokeWidth="2"
      />
    </svg>
  );
};

export default GreenLem;
